import Tailer_One from "../../../assets/images/Tailer_One.jpg";
import Tailer_Two from "../../../assets/images/Tailer_Two.jpg";
import Accessory_Two from "../../../assets/images/Accessory_Two.png";
import Accessory_Three from "../../../assets/images/Accessory_Three.png";
import Center_Console_Two from "../../../assets/images/Center_Console_Two.jpg";
import Center_Console_One from "../../../assets/images/Center_Console_One.jpg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { useRef } from "react";
const CustomPrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} custom-arrow custom-prev`}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        left: "10px", // Adjust left position
        zIndex: 1, // Ensure it appears above everything
        backgroundColor: "rgba(0,0,0,0.5)", // Semi-transparent background
        width: "40px",
        height: "40px",
        borderRadius: "50%", // Circular button
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      {/* <span style={{ color: "#fff", fontSize: "24px" }}>◀</span> */}
    </div>
  );
};

// Custom Right Arrow
const CustomNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} custom-arrow custom-next`}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        right: "20px", // Adjust right position
        zIndex: 1, // Ensure it appears above everything
        backgroundColor: "rgba(0,0,0,0.5)", // Semi-transparent background
        width: "40px",
        height: "40px",
        borderRadius: "50%", // Circular button
        cursor: "pointer",
        opacity: 1,
      }}
      onClick={onClick}
    >
      {/* <span style={{ color: "#fff", fontSize: "24px" }}>▶</span> */}
    </div>
  );
};
const NZOtherAccessories = () => {
  const accessories = [
    {
      id: 1,
      image: [Tailer_One, Tailer_Two],
      name: "Trailer",
      details: [
        "Trailer cargo tray hoist can be operated from Tuatara  passenger cabin.",
        "Fitted with tail, braking, reversing, number plate and turn signal lights.",
        "Dual coil springs on both wheels.",
        "Can be road registered.",
        "Can be fitted with a deck cage.",
        "Can be attached to other vehicles.",
        "Dimensions: (L x W) 2760 x 1480mm.",
        "Deck dimensions: (L x W x H) 1600 x 1400 x 300mm.",
        "Carrying capacity: 800kg.",
      ],
    },
    {
      id: 2,
      image: [Accessory_Three],
      name: "Cage",
      details: [
        "Stainless steel construction.",
        "Installable on vehicle or trailer.",
        "Sliding rear gates (2) with latch.",
        "Available for petrol & electric models.",
      ],
    },
    {
      id: 3,
      image: [Accessory_Two],
      name: "Accessory Bench Seat",
      details: ["Head protection in the event of roll-over", "4-point seat belts", "Solidly bolted to cargo bed"],
    },
    {
      id: 4,
      image: [Center_Console_One, Center_Console_Two],
      name: "Centre Console",
      details: ["Seat covers", "Heavy duty rubber mat rear cargo deck"],
    },
    {
      id: 4,
      image: [],
      name: "Extras",
      details: ["Seat covers", "Heavy duty rubber mat rear cargo deck"],
    },
  ];
  return (
    <div className="mt-[30px] mb-[30px]">
      <div className="custom-container px-[30px] text-start mx-auto">
        <div className="max-w-[1200px] mx-auto">
          <h2 className="text-[48px] md:text-[36px] text-gray-800 kuunari-bold text-center mb-10">
            Other Accessories:
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-x-8 gap-4">
            {accessories.map((accessory) => (
              <AccessoryItem key={accessory.id} {...accessory} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

function AccessoryItem({ image, name, details }) {
  const sliderRef = useRef(null);
  const settings = {
    // dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 8000, // Slower slide change (was 6000)
    // prevArrow: <CustomPrevArrow />, // Custom arrow components
    // nextArrow: <CustomNextArrow />,
  };
  return (
    <article className="text-center ">
      {image && image.length > 1 && (
        // <Slider {...settings} className="w-full h-[400px] rounded-lg">
        //   {image.map((img, index) => (
        //     <div key={index} className="w-full h-[400px]">
        //       <img
        //         src={img}
        //         alt={`${name} ${index + 1}`}
        //         className="w-full h-[400px]  rounded-lg object-cover"
        //         loading="lazy"
        //       />
        //     </div>
        //   ))}
        // </Slider>
        <div className="relative w-full">
          {/* Custom Previous Arrow */}
          {image.length > 1 && (
            <div
              className="absolute left-[10px] top-1/2 transform -translate-y-1/2 z-10 bg-black w-8 h-8 rounded-full flex items-center justify-center cursor-pointer p-1"
              onClick={() => sliderRef.current?.slickPrev()}
            >
              <FaChevronLeft className="text-white text-sm" />
            </div>
          )}

          {/* Image Slider */}
          <Slider ref={sliderRef} {...settings} className="w-full h-[400px] rounded-lg">
            {image.map((img, index) => (
              <div key={index} className="w-full h-[400px]">
                <img
                  src={img}
                  alt={`Accessory ${index + 1}`}
                  className="w-full h-[400px] rounded-lg object-cover"
                  loading="lazy"
                />
              </div>
            ))}
          </Slider>

          {/* Custom Next Arrow */}
          {image.length > 1 && (
            <div
              className="absolute right-[10px] top-1/2 transform -translate-y-1/2 z-10 bg-black w-8 h-8 rounded-full flex items-center justify-center cursor-pointer p-1"
              onClick={() => sliderRef.current?.slickNext()}
            >
              <FaChevronRight className="text-white text-sm" />
            </div>
          )}
        </div>
      )}
      {image && image.length == 1 && (
        <div className="w-full h-[400px]">
          <img src={image} className="w-full h-[400px]  rounded-lg object-cover" loading="lazy" />
        </div>
      )}
      <h3 className="text-[22px] kuunari-bold text-gray-800 mb-2 text-center">{name}</h3>
      <AccessoryDetails details={details} />
    </article>
  );
}

function AccessoryDetails({ details }) {
  return (
    <ul className="text-left text-gray-600 text-[16px] space-y-1">
      {details.map((detail, index) => (
        <li key={index} className="flex items-start gap-2">
          <span>➢</span> {detail}
        </li>
      ))}
    </ul>
  );
}

export default NZOtherAccessories;
